import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { media } from '../theme/media';

import Link from './Link';
import { ReactComponent as IconArrowRight } from '../images/icons/arrow-right.svg';
import TextRenderer from './TextRenderer';

const Arrow = styled(IconArrowRight)`
  display: inline-block;
  width: ${rem(20)};
  margin-left: ${rem(8)};
  transform: translateY(10%);
  transition: all .2s ease;

  ${media('>tiny')} {
    width: ${rem(24)};
  }
`;

const Box = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${rem(12)} ${rem(16)};
  font-size: ${rem(14)};
  background: ${colors.blue['800']};
  color: ${colors.gray['200']};

  ${media('>tiny')} {
    font-size: ${rem(16)};
    padding: ${rem(14)} ${rem(20)};
  }

  &:focus,
  &:hover {

    ${Arrow} {
      transform: translateX(${rem(8)}) translateY(10%);
    }
  }
`;

const Text = styled.div`
  display: inline-block;
`;

const Banner = ({ text, link }) => {
  const content = (
    <Box>
      <Text>
        <TextRenderer text={text} />
        {link && <Arrow aria-hidden="true" />}
      </Text>
    </Box>
  );

  if (!link) {
    return content;
  }

  return (
    <Link to={link}>
      {content}
    </Link>
  );
};

Banner.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string
};

export default Banner;
